import { useEffect, useState } from "react";

/**
 * One avatar for the whole app: the person's photo when we have a usable URL,
 * their initials otherwise (and on a broken image). `className` carries the size,
 * border colour and fallback background (e.g. "border-ink bg-acid h-10 w-10
 * text-xs"), so each call site keeps its own look while the image/initials logic
 * stays in one place.
 */
export function Avatar({
  name,
  url,
  className,
}: {
  name: string;
  url?: string | null;
  className?: string;
}) {
  const [broken, setBroken] = useState(false);
  // A new url deserves a fresh attempt — otherwise a previously-broken image
  // would keep showing initials even after the photo is updated.
  useEffect(() => setBroken(false), [url]);
  const showImage = Boolean(url) && !broken;
  return (
    <span
      className={`border-chip relative grid shrink-0 place-items-center overflow-hidden ${className ?? ""}`}
    >
      {showImage ? (
        <img
          src={url as string}
          alt={name}
          className="absolute inset-0 h-full w-full object-cover"
          onError={() => setBroken(true)}
        />
      ) : (
        <span className="font-display font-extrabold">
          {name.slice(0, 2).toUpperCase()}
        </span>
      )}
    </span>
  );
}
